module.exports = __webpack_public_path__ + "static/media/phone-kor.20ad2674.png";